module.exports = {
	"articleTitle1": "In three houses, Baits goes strictly freshmen",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Baits Houses",
	"articleLink1": "https://www.michigandaily.com/content/2009-04-01/three-houses-baits-goes-all-freshmen",
	"articleLink2": "https://www.michigandaily.com/news/fate-baits-i",
	"articleSnippet1": "Mar 31, 2009 ... Beginning in the fall semester of 2009, the Cross, Conger and Coman houses in \nBaits II will be designated strictly as freshman-only housing.",
	"articleSnippet2": "Nov 8, 2011 ... For the 571 students currently living in Baits I Residence Hall, their year in the \nNorth Campus housing complex may mark the end of the Baits I ...",
	"totalMisc": 0,
	"articleTitle2": "closing of Baits I",
	"address": "1440 Hubbard, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.294386,
		"lng": -83.723825
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/baits.json
// module id = 819
// module chunks = 0